import React, { useState, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import { TextField, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { DeliverableStatus, ProjectDeliverableStatus } from "../../constants/Status";
import { AcceptFileType, Action } from "../../constants/Common";
import { useFormik } from "formik";
import * as Yup from "yup";
import { rejectLegalDeliverable, updateDeliverableStatus } from "../../api/casp/deliverable";
import { Spinner } from "reactstrap";
// import AttachFileIcon from '@material-ui/icons/AttachFile';
import { DocumentModule, Modules } from "../../constants/Module";
import { deleteDocument, documentList, documentListForProject, uploadFile } from "../../api/casp/document";
import Loader from "../Common/Loader";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
// import { makeStyles } from "@material-ui/core";
import DocumentFilePreviewModal from "../casp/common/DocumentFilePreviewModal";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { getUrl } from "../../helpers/file_helper";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import { updateApprovalStatus } from "../../api/casp/approval";
import { middleTruncate } from "../../helpers/string_helper";

const useStyles = makeStyles({
  blueIcon: {
    color: '#296ced',
    cursor: 'pointer'
  },
});

const SubmitLegalDocumentComment = ({
  isOpen,
  handleClose,
  selectedRow,
  refresh,
  isDisabled,
  action,
  t,
  source = '',
  submit,
}) => {
  const [isLoading, setIsLoading] =
    useState(false);
  const [disabled, setDisabled] = useState(false);
  const [trigger, setTrigger] = useState(new Date())
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [filePath, setFilePath] = useState('');
  const [fileName, setFileName] = useState('');
  const [crnNameFiles, setCrnNameFiles] = useState({});
  const [crnNumberFiles, setCrnNumberFiles] = useState({});
  const [iBanNumberFiles, setIBanNumberFiles] = useState({});
  const [establishmentContractFiles, setEstablishmentContractFiles] = useState({});
  const [agreementDocFiles, setAgreementDocFiles] = useState({});
  // const [rcFiles, setRcFiles] = useState({});
  const [modal, setModal] = useState(false);
  const classes = useStyles();
  const [crnNameLoading, setCrnNameLoading] = useState(false);
  const [crnNumberLoading, setCrnNumberLoading] = useState(false);
  const [iBanNumberLoading, setIBanNumberLoading] = useState(false);
  const [establishmentContractLoading, setEstablishmentContractLoading] = useState(false);
  const [agreementDocFileLoading, setAgreementDocFileLoading] = useState(false);
  // const [RCFileLoading, setRCFileLoading] = useState(false);
  const [deletingFileType, setDeletingFileType] = useState('');
  const deliverableValidation = Yup.object().shape({
    crnNameComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
    crnNumberComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
    bankNameComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
    iBanNumberComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
     agreementDocumentComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
      establishmentContractComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
      // acknowledgementRCComment: Yup.string()
      // .max(250, t("Too Long!"))
      // .strict(true)
      // .trim(t('Must not include leading and trailing spaces'))
      // .optional(),
  });

  const formik = useFormik({
    initialValues: {
      // name: selectedRow?.deliverable.name ?? "",
      // startDate: selectedRow?.deliverable.startDate ?? "",
      // endDate: selectedRow?.deliverable.endDate ?? "",
      // crnName: selectedRow?.crnName ?? "",
      // crnNumber: selectedRow?.crnNumber ?? "",
      // bankName: selectedRow?.bankName ?? "",
      // iBanNumber: selectedRow?.iBanNumber ?? "",
      // crnNameAttachmentId: "",
      // crnNumAttachmentId: "",
      // iBanNumAttachmentId: "",
      // establishmentContractAttachmentId: "",
      // agreementDocFileId: "",
      crnNameComment: selectedRow?.deliverableRejectComments[0]?.crnNameComment ? selectedRow?.deliverableRejectComments[0]?.crnNameComment : '',
      crnNumberComment: selectedRow?.deliverableRejectComments[0]?.crnNumberComment ? selectedRow?.deliverableRejectComments[0]?.crnNumberComment : '',
      bankNameComment: selectedRow?.deliverableRejectComments[0]?.bankNameComment ? selectedRow?.deliverableRejectComments[0]?.bankNameComment : '',
      iBanNumberComment: selectedRow?.deliverableRejectComments[0]?.iBanNumberComment ? selectedRow?.deliverableRejectComments[0]?.iBanNumberComment : '',
      agreementDocumentComment: selectedRow?.deliverableRejectComments[0]?.agreementDocumentComment ? selectedRow?.deliverableRejectComments[0]?.agreementDocumentComment : '',
      establishmentContractComment: selectedRow?.deliverableRejectComments[0]?.establishmentContractComment ? selectedRow?.deliverableRejectComments[0]?.establishmentContractComment : '',
      // acknowledgementRCComment: '',
    },
    validationSchema: deliverableValidation,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true
  });

  useEffect(() => {
    if (selectedRow && action !== Action.EDIT) {
      getDocumentList()
      // if (
      //   ![DeliverableStatus.DRAFT, DeliverableStatus.REJECTED].includes(
      //     selectedRow.currentStatus
      //   ) ||
      //   isDisabled || action === Action.VIEW || action === Action.SUBMIT
      // ) {
      //   setDisabled(true);
      // } else {
      //   setDisabled(false);
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow]);

  const getDocumentList = async () => {
    try {
      setCrnNameLoading(true)
      setCrnNumberLoading(true)
      setIBanNumberLoading(true)
      setEstablishmentContractLoading(true)
      setAgreementDocFileLoading(true)
      // setRCFileLoading(false)
      let params = {
        projectId: source === 'ActionList' ? selectedRow.project.id : selectedRow.projectId,
        filterFields: ['documentAssociations'],
        filterInputs: '',
        module: Modules.PROJECT_DELIVERABLE,
        moduleId: source = selectedRow.id
      };
      const documentData = await documentListForProject(params)
      const documentDataList = documentData.data.data

      // First set all file states
      documentDataList.forEach(dl => {
        if (dl.documentType.name === 'CRN Name') {
          setCrnNameFiles(dl)
          formik.setFieldValue('crnNameAttachmentId', dl.id)
        }
        if (dl.documentType.name === 'CRN Number') {
          setCrnNumberFiles(dl)
          formik.setFieldValue('crnNumAttachmentId', dl.id)
        }
        if (dl.documentType.name === 'IBAN Certificate') {
          setIBanNumberFiles(dl)
          formik.setFieldValue('iBanNumAttachmentId', dl.id)
        }
        if (dl.documentType.name === 'Establishmnent Contract') {
          setEstablishmentContractFiles(dl)
          formik.setFieldValue('establishmentContractAttachmentId', dl.id)
        }
        if (dl.documentType.name === 'Agreement Document') {
          setAgreementDocFiles(dl)
          formik.setFieldValue('agreementDocFileId', dl.id)
        }
        // if (dl.documentType.name === 'Acknowledgement of the RC') {
        //   setRcFiles(dl)
        //   formik.setFieldValue('rcFileId', dl.id)
        // }
      });

      setCrnNameLoading(false)
      setCrnNumberLoading(false)
      setIBanNumberLoading(false)
      setEstablishmentContractLoading(false)
      setAgreementDocFileLoading(false)
      // setRCFileLoading(false)

    } catch (err) {
      console.log(err)
      setCrnNameLoading(false)
      setCrnNumberLoading(false)
      setIBanNumberLoading(false)
      setEstablishmentContractLoading(false)
      setAgreementDocFileLoading(false)
      // setRCFileLoading(false)
    }
  }

  const deliverableSubmit = async () => {
    try {
      setIsLoading(true);

      const payload = {
        deliverableComment: {
          crnNameComment: formik.values?.crnNameComment,
          crnNumberComment: formik.values.crnNumberComment,
          bankNameComment: formik.values.bankNameComment,
          iBanNumberComment: formik.values.iBanNumberComment,
          establishmentContractComment: formik.values.establishmentContractComment,
          agreementDocumentComment: formik.values.agreementDocumentComment,
          // acknowledgementRCComment: formik.values.acknowledgementRCComment
        },
        status: ProjectDeliverableStatus.REJECTED,
        projectId: parseInt(selectedRow.projectId),
        moduleId: selectedRow.moduleId,
        module: selectedRow.actionType,
        deliverableOrder: selectedRow?.deliverable?.deliverableOrder
      };

      const res = await updateApprovalStatus(selectedRow?.approvalId, payload);

      if (res.statusCode === 200) {
        toast.success(res.data.message);
        refresh();
      } else {
        toast.error(res.message);
      }

      handleClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
    }
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={handleClose}
        className="projectListDrawer"
        PaperProps={{
          sx: { width: "580px" },
        }}
      >
        <form className="editMilestoneDrawer p-3">
          <h5>{t("Deliverable")}</h5>
          <CloseIcon className="crossIcon" onClick={handleClose} />
          <div className="innerTbContent">
            <div className="row">
              {/* Name */}
              <div className="col-sm-12 mb-3">
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label={t("Name")}
                  name="name"
                  value={selectedRow?.deliverable?.name}
                  inputProps={{
                    readOnly: disabled,
                  }}
                  required
                />
              </div>
              {/* Start Date */}
              <div className="col-sm-6 mb-3 plDatepicker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      label={t("Start Date") + " *"}
                      name="startDate"
                      format="MM/DD/YYYY"
                      value={
                        selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate?.toString().trim()
                          ? dayjs(selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate)
                          : dayjs(selectedRow.deliverable?.startDate)
                      }
                      on
                      readOnly={
                        disabled

                      }
                      required
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              {/* End Date */}
              <div className="col-sm-6 mb-3 plDatepicker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      label={t("End Date") + " *"}
                      name="endDate"
                      format="MM/DD/YYYY"
                      value={
                        selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate?.toString().trim()
                          ? dayjs(selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate)
                          : dayjs(selectedRow?.deliverable?.endDate)
                      }
                      readOnly={
                        isLoading || disabled
                      }
                      required
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <div className="col-sm-12 mb-3">
                <>
                  <TextField
                    fullWidth
                    className="form-control"
                    id="deliverable-title-input"
                    label={t("Description")}
                    name="description"
                    value={selectedRow?.description}
                    disabled={isDisabled}
                    multiline
                    rows={2}
                  />
                </>
                {/* : <></>)} */}
              </div>
              {/* Crn Name */}
              <div className="col-sm-12 mb-3">
                {/* {((action === Action.VIEW && deliverableObject.crnName !== "") || (action !== Action.VIEW) ? */}
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="outlined-basic"
                    label={t("CR Name")}
                    name="crnName"
                    value={selectedRow.crnName}
                    type="text"
                    disabled={isDisabled}
                    // onKeyDown={handleKeyDownWeight}
                    required
                  />
                  <div className="mt-3">
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="outlined-basic"
                      label={t("CR Name Comment")}
                      name="crnNameComment"
                      multiline
                      rows={3}
                      value={formik.values.crnNameComment}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      disabled={isLoading}
                      // onKeyDown={handleKeyDownWeight}
                      required
                    />
                    {formik.touched.crnNameComment && formik.errors.crnNameComment && (
                      <span className="text-danger">{formik.errors.crnNameComment}</span>
                    )}
                  </div>
                </>
              </div>
              {/* CRN Name Attachment */}
              {
                <>
                  <div>
                  {!crnNameLoading && Object.keys(crnNameFiles).length > 0 && (
                    <h5 className="mb-0">{t("Attached CR Name Document") + ":"}</h5>
                  )}
                    {crnNameLoading && <Loader />}
                    {
                      !crnNameLoading && Object.keys(crnNameFiles).length > 0 &&
                      // && crnNameFiles?.length > 0 && crnNameFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between'>
                          <span className='fw-semibold text-truncate' title={crnNameFiles?.name}>
                            {middleTruncate(crnNameFiles?.name)}
                          </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(crnNameFiles.storageLink))
                              setFileName(middleTruncate(crnNameFiles?.name))
                            }} />
                          </div>
                        </div>
                        <br />
                      </>
                      // ))
                    }
                  </div>
                </>
              }
              {/* Crn Number */}
              <div className="col-sm-12 mb-3">
                {/* {((action === Action.VIEW && deliverableObject.crnNumber !== "") || (action !== Action.VIEW) ? */}
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="outlined-basic"
                    label={t("CR Number")}
                    name="crnNumber"
                    value={selectedRow?.crnNumber}
                    type="text"
                    disabled={isDisabled}
                    required
                  />
                  <div className="mt-3">
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="outlined-basic"
                      label={t("CR Number Comment")}
                      multiline
                      rows={3}
                      name="crnNumberComment"
                      value={formik.values.crnNumberComment}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      disabled={isLoading}
                      required
                    />
                    {formik.touched.crnNumberComment && formik.errors.crnNumberComment && (
                      <span className="text-danger">{formik.errors.crnNumberComment}</span>
                    )}
                  </div>
                </>
                {/* : <></>)} */}
              </div>
              {/* CRN Number Attachment */}
              {
                <>
                  <div>
                  {!crnNumberLoading && Object.keys(crnNumberFiles).length > 0 && (
                    <h5 className="mb-0">{t("Attached CR Number Document") + ":"}</h5>
                  )}
                    {crnNumberLoading && <Loader />}
                    {
                      !crnNumberLoading && Object.keys(crnNumberFiles).length > 0 &&
                      // crnNumberFiles?.length > 0 && crnNumberFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between' >
                          {/* key={key}> */}
                          <span className='fw-semibold text-truncate' title={crnNumberFiles?.name}>
                            {middleTruncate(crnNumberFiles?.name)}
                          </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(crnNumberFiles.storageLink))
                              setFileName(middleTruncate(crnNumberFiles?.name))
                            }} />
                          </div>
                        </div>
                        <br />
                      </>
                      // ))
                    }
                  </div>
                </>
              }
              {/* Iban Number */}
              <div className="col-sm-12 mb-3">
                {/* {((action === Action.VIEW && deliverableObject.crnName !== "") || (action !== Action.VIEW) ? */}
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="outlined-basic"
                    label={t("IBAN Number")}
                    name="iBanNumber"
                    value={selectedRow?.iBanNumber}
                    type="text"
                    disabled={isDisabled}
                    required
                  />
                  <div className="mt-3">
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="outlined-basic"
                      label={t("IBAN Number Comment")}
                      name="iBanNumberComment"
                      multiline
                      rows={3}
                      value={formik.values.iBanNumberComment}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      disabled={isLoading}
                      required
                    />
                    {formik.touched.iBanNumber && formik.errors.iBanNumber && (
                      <span className="text-danger">{formik.errors.iBanNumber}</span>
                    )}
                  </div>
                </>
                {/* : <></>)} */}
              </div>
              {/* IBAN No Certificate Attachment */}
              {
                <>
                  <div>
                  {!iBanNumberLoading && Object.keys(iBanNumberFiles).length > 0 && (
                    <h5 className="mb-0">{t("Attached IBan No Certificates") + ":"}</h5>
                  )}
                    {iBanNumberLoading && <Loader />}
                    {
                      !iBanNumberLoading && Object.keys(iBanNumberFiles).length > 0 &&
                      // iBanNumberFiles?.length > 0 && iBanNumberFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between'>
                          <span className='fw-semibold text-truncate' title={iBanNumberFiles?.name}>
                            {middleTruncate(iBanNumberFiles?.name)}
                          </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(iBanNumberFiles.storageLink))
                              setFileName(middleTruncate(iBanNumberFiles?.name))
                            }} />
                          </div>
                        </div>
                        <br />
                      </>
                      // ))
                    }
                  </div>
                </>
              }
              {/* Bank Name */}
              <div className="col-sm-12 mb-3">
                {/* {((action === Action.VIEW && deliverableObject.crnName !== "") || (action !== Action.VIEW) ? */}
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="outlined-basic"
                    label={t("Bank Name")}
                    name="bankName"
                    value={selectedRow?.bankName}
                    type="text"
                    disabled={isDisabled}
                    // onKeyDown={handleKeyDownWeight}
                    required
                  />
                  <div className="mt-3">
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="outlined-basic"
                      label={t("Bank Name Comment")}
                      name="bankNameComment"
                      multiline
                      rows={3}
                      value={formik.values.bankNameComment}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      disabled={isLoading}
                      // onKeyDown={handleKeyDownWeight}
                      required
                    />
                    {formik.touched.bankNameComment && formik.errors.bankNameComment && (
                      <span className="text-danger">{formik.errors.bankNameComment}</span>
                    )}
                  </div>
                </>
                {/* : <></>)} */}
              </div>
              {/* Establishment Contract Attachment */}
              {
                <>
                  <div>
                    <h5 className="mb-0">{t("Attached Article of Association") + ":"}</h5>
                    {establishmentContractLoading && <Loader />}
                    {
                      !establishmentContractLoading && Object.keys(establishmentContractFiles).length > 0 &&
                      // establishmentContractFiles?.length > 0 && establishmentContractFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between'>
                          <span className='fw-semibold text-truncate' title={establishmentContractFiles?.name}>
                            {middleTruncate(establishmentContractFiles?.name)}
                          </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(establishmentContractFiles.storageLink))
                              setFileName(middleTruncate(establishmentContractFiles?.name))
                            }} />
                          </div>
                        </div>
                        <div className="mt-3">
                          <TextField
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            id="outlined-basic"
                            label={t("Article of Association")}
                            name="establishmentContractComment"
                            multiline
                            rows={3}
                            value={formik.values.establishmentContractComment}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            type="text"
                            disabled={isLoading}
                            // onKeyDown={handleKeyDownWeight}
                            required
                          />
                          {formik.touched.establishmentContractComment && formik.errors.establishmentContractComment && (
                            <span className="text-danger">{formik.errors.establishmentContractComment}</span>
                          )}
                        </div>
                        <br />
                      </>
                      // ))
                    }
                  </div>
                </>
              }

              {/* Agreement Document Attachment */}
              {
                <>
                  <div>
                  {!agreementDocFileLoading && Object.keys(agreementDocFiles).length > 0 && (
                    <h5 className="mb-0">{t("Attached MISA Agreement") + ":"}</h5>
                  )}
                    {agreementDocFileLoading && <Loader />}
                    {
                      !agreementDocFileLoading && Object.keys(agreementDocFiles).length > 0 &&
                      // establishmentContractFiles?.length > 0 && establishmentContractFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between'>
                          <span className='fw-semibold text-truncate' title={agreementDocFiles?.name}>
                            {middleTruncate(agreementDocFiles?.name)}
                          </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(agreementDocFiles.storageLink))
                              setFileName(middleTruncate(agreementDocFiles?.name))
                            }} />
                          </div>
                        </div>

                        <div className="mt-3">
                          <TextField
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            id="outlined-basic"
                            label={t("MISA Agreement Comment")}
                            name="agreementDocumentComment"
                            multiline
                            rows={3}
                            value={formik.values.agreementDocumentComment}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            type="text"
                            disabled={isLoading}
                            // onKeyDown={handleKeyDownWeight}
                            required
                          />
                          {formik.touched.agreementDocumentComment && formik.errors.agreementDocumentComment && (
                            <span className="text-danger">{formik.errors.agreementDocumentComment}</span>
                          )}
                        </div>
                        <br />
                      </>
                      // ))
                    }
                  </div>
                </>
              }

              {/* Acknowledgement of the RC */}
              {/* {
                <>
                  <div>
                    <h5 className="mb-0">{t("Attached Acknowledgement of the RC Document") + ":"}</h5>
                    {RCFileLoading && <Loader />}
                    {
                      !RCFileLoading && Object.keys(rcFiles).length > 0 &&
                      // establishmentContractFiles?.length > 0 && establishmentContractFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between'>
                          <span className='fw-semibold text-truncate'>{rcFiles?.name} </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(rcFiles.storageLink))
                              setFileName(rcFiles.name)
                            }} />
                          </div>
                        </div>

                        <div className="mt-3">
                          <TextField
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            id="outlined-basic"
                            label={t("Acknowledgement of the RC Comment")}
                            name="acknowledgementRCComment"
                            multiline
                            rows={3}
                            value={formik.values.acknowledgementRCComment}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            type="text"
                            disabled={isLoading}
                            // onKeyDown={handleKeyDownWeight}
                            required
                          />
                          {formik.touched.acknowledgementRCComment && formik.errors.acknowledgementRCComment && (
                            <span className="text-danger">{formik.errors.acknowledgementRCComment}</span>
                          )}
                        </div>
                        <br />
                      </>
                      // ))
                    }
                  </div>
                </>
              } */}
            </div>
          </div>

          {action === Action.SUBMIT && (
            <div className="plsubmitButton justify-content-center mt-4">
              <Button
                onClick={deliverableSubmit}
                disabled={
                  isLoading ||
                  !(formik.values?.bankNameComment || 
                    formik.values?.crnNameComment || 
                    formik.values?.crnNumberComment || 
                    formik.values?.iBanNumberComment || 
                    formik.values?.agreementDocumentComment || 
                    formik.values?.establishmentContractComment
                    // formik.values?.acknowledgementRCComment
                  )
                }
                className="btn addNew_ProjectBtn"
              >
                {isLoading && (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-1"
                  />
                )}
                {t("Submit")}
              </Button>
            </div>
          )}
        </form>
      </Drawer >

      {
        modal && (
          <DocumentFilePreviewModal modal={modal} setModal={setModal} filePath={filePath} fileName={fileName} />
        )
      }
    </>
  );
};

export default withTranslation()(SubmitLegalDocumentComment);
